import React from "react";
import DynamicSimpleTable from "../../../../../../../util/DynamicSimpleReactTable";
import { formatDate, formatStatus, errorMessage, formatUsername } from "../../../../../../../util/Helpers";
import cogoToast from "cogo-toast";

const Referrals = ({
    match: {
        params: {
            referralCode
        }
    }
}) => {

    return <div className="card card-custom gutter-b">
        <div className="row">
            <div className="col-12">
                {/* <!--begin::List Widget 14--> */}
                <div className="card card-custom gutter-b">
                    {/* <!--begin::Header--> */}
                    <div className="card-header border-0">
                        {/* <!--begin::Title--> */}
                        <div className="card-title pt-5 w-100">
                            <h3 className="card-label">
                                <span className="d-block text-dark h3 font-weight-bolder">User Referrals</span>
                                <span className="d-block text-muted mt-2 font-size-sm">Referrals</span>
                            </h3>
                        </div>
                    </div>
                    {/* <!--end::Header--> */}
                    {/* <!--begin::Body--> */}
                    <div className="card-body pt-0">
                        <DynamicSimpleTable
                        key={referralCode}
                        searchBox={false}
                        source={{ url: `/users/referrals/${referralCode}` }}
                            columns={[
                                { title: "USER", format: row => formatUsername(row.userId, `${row.firstName || row.userId} ${row.lastName || ""}`)},
                                { title: "EMAIL", key: "email" },
                                { title: "PHONE", key: "phone" },
                                { title: "USER GROUP", key: "userGroup" },
                                { title: "STATUS", format: row => formatStatus(row.status) },
                                { title: "CREATED AT", format: row => formatDate(row.created) },
                            ]}
                            onError={(err) =>
                                cogoToast.error(errorMessage(err))
                            }
                            refreshIcon={true}
                        />
                    </div>
                    {/* <!--end::Body--> */}
                </div>
                {/* <!--end::List Widget 14--> */}
            </div>
        </div>
    </div>

}

export default Referrals;